import { useState } from "react";

/* Collapsed "What's this?" disclosure for an admin section.
 *
 * Collapsed by default on purpose: an admin who has done this before shouldn't
 * have to scroll past a paragraph every season, and one who hasn't shouldn't
 * have to guess what "Clear Data" destroys. */
export function SectionHelp({ label = "What's this?", children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-3">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="text-xs font-medium text-blue-600 hover:text-blue-800"
      >
        {open ? "Hide help" : label}
      </button>
      {open && (
        <div className="mt-2 rounded-lg bg-blue-50 border border-blue-100 px-3 py-2 space-y-1.5 text-xs leading-relaxed text-blue-900">
          {children}
        </div>
      )}
    </div>
  );
}
